var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "circle-checkmark",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.63 8.38c.49-.49.49-1.28 0-1.77a1.25 1.25 0 0 0-1.77 0l-4.12 4.12-1.62-1.62a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77l2.5 2.5c.49.49 1.28.49 1.77 0l5-5Z"
  })));
};
export default SvgCircleCheck;